import React, { useMemo, useState } from "react";
import  { Form, FormGroup, Dropdown, Radio, FormField } from "semantic-ui-react";

// Common
import DateTextBox from "react-lib/apps/common/DateTextBox";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { useIntl } from "react-intl";

// Interface
import { State } from "./sequence/ClinicAnnualReport";

// Type
type CardClinicRevenueReportFilterProps = {
  runSequence: any;
  setProp: any;
  buttonLoadCheck: Record<string, any>;
  // Seq
  ClinicAnnualReportSequence: State["ClinicAnnualReportSequence"];
  masterOptions?: Record<string, any>;
  languageUX: "en" | "th";
};

const CardClinicRevenueReportFilter = (props: CardClinicRevenueReportFilterProps) => {
  const intl = useIntl();

  // useState
  const [requiredStartDate, setRequiredStartDate] = useState<boolean>(false);

  // UseMemo
  const coverageOptions = useMemo(() => {
    return [
      { key: "ALL", value: "ALL", text: "แสดงทุกสิทธิ" },
      ...(props.masterOptions?.coverage || []),
    ];
  }, [props.masterOptions?.coverage]);

  const positionOptions = useMemo(() => {
    return [
      { key: "ALL", value: "ALL", text: "แสดงทุกตำแหน่ง" },
      ...(props.masterOptions?.positionAll || []),
    ];
  }, [props.masterOptions?.positionAll]);

  const handleDownloadButton = () => {
    if (requiredStartDate) {
      alert("กรุณาระบุวันที่รับบริการ");
    } else {
      props.runSequence({
        sequence: "ClinicAnnualReport",
        action: "DOWNLOAD_REPORT",
        menu: "รายงานสรุปรายได้คลินิก",
      });
    }
  };

  return (
    <Form>
      <FormGroup style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label style={{ display: "flex", alignItems: "center", padding: "0rem 0.5rem 0rem 0rem" }}>
          วันที่รับบริการ<span style={{ color: "red" }}>*</span>
        </label>
        <DateTextBox
          onChange={(date: string) => {
            props.setProp(`ClinicAnnualReportSequence.clinicRevenueReport.filterStartDate`, date);
            if ((props.ClinicAnnualReportSequence?.clinicRevenueReport?.filterStartDate || "").length < 1) {
              setRequiredStartDate(true);
            } else {
              setRequiredStartDate(false);
            }
          }}
          style={{ width: "11rem" }}
          value={props.ClinicAnnualReportSequence?.clinicRevenueReport?.filterStartDate || ""}
        ></DateTextBox>
        <label style={{ display: "flex", alignItems: "center" }}>
          {intl.formatMessage({ id: "ถึง" })}
        </label>
        <DateTextBox
          onChange={(date: string) => 
            props.setProp(
              `ClinicAnnualReportSequence.clinicRevenueReport.filterEndDate`,
              date
            )
          }
          style={{ width: "11rem" }}
          value={props.ClinicAnnualReportSequence?.clinicRevenueReport?.filterEndDate || ""}
        ></DateTextBox>
      </FormGroup>
      <FormGroup style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label style={{ display: "flex", alignItems: "center", padding: "0rem 0.3rem 0rem 0rem" }}>
          ตำแหน่งแพทย์
        </label>
        <Dropdown
          value={props.ClinicAnnualReportSequence?.clinicRevenueReport?.positionDoctor || ""}
          onChange={(e: any, data: any) => 
            props.setProp(
              `ClinicAnnualReportSequence.clinicRevenueReport.positionDoctor`,
              data.value
            )
          }
          placeholder={intl.formatMessage({ id: "เลือกตำแหน่งแพทย์" })}
          options={positionOptions}
          search
          selection
          style={{ minWidth: "15.5rem" }}
        />
        <label style={{ display: "flex", alignItems: "center" }}>
          ตำแหน่งนิสิต
        </label>
        <Dropdown
          value={props.ClinicAnnualReportSequence?.clinicRevenueReport?.positionStudent || ""}
          onChange={(e: any, data: any) =>
            props.setProp(
              `ClinicAnnualReportSequence.clinicRevenueReport.positionStudent`,
              data.value
            )
          }
          placeholder="เลือกตำแหน่งนิสิต"
          options={positionOptions}
          search
          selection
          style={{ minWidth: "15.5rem" }}
        />
      </FormGroup>
      <FormGroup inline style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label style={{ display: "flex", alignItems: "center", padding: "0rem 0.8rem 0rem 0rem" }}>
          สิทธิรักษา
        </label>
        <Dropdown
          value={props.ClinicAnnualReportSequence?.clinicRevenueReport?.coverageSelected || ""}
          onChange={(e: any, data: any) => 
            props.setProp(
              `ClinicAnnualReportSequence.clinicRevenueReport.coverageSelected`,
              data.value
            )
          }
          placeholder={intl.formatMessage({ id: "เลือกสิทธิ" })}
          options={coverageOptions}
          search
          selection
          style={{ minWidth: "15.5rem" }}
        />
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 9rem 0rem 0rem",
          }}
        ></label>
        <ButtonLoadCheck
          setProp={props.setProp}
          onClick={handleDownloadButton}
          paramKey={`ClinicAnnualReport_DOWNLOAD_REPORT`}
          buttonLoadCheck={props.buttonLoadCheck?.[`ClinicAnnualReport_DOWNLOAD_REPORT`]}
          color="green"
          style={{ width: "11rem" }}
          title={intl.formatMessage({ id: "ดาวน์โหลด xlsx" })}
        />
      </FormGroup>
    </Form>
  );
};

export default CardClinicRevenueReportFilter;